// extracted by mini-css-extract-plugin
export default {"container_p":"PokemonList_container_p__v8nN-","nopokemons":"PokemonList_nopokemons__N8MBD"};